import i18n from "../constants/localization/config";
import {
  PREFERRED_LANGUAGE_CODE_MAP,
  PREFERRED_LANGUAGE_CODE_TO_I18N,
} from "./doctorProfileApi";

export const normalizeI18nLanguage = (lng) =>
  String(lng || "tr").toLowerCase().split("-")[0];

export const getI18nLanguageFromCode = (code) => {
  if (code == null) return null;
  if (typeof code === "string" && code in PREFERRED_LANGUAGE_CODE_MAP) {
    return normalizeI18nLanguage(code);
  }
  const numericCode = Number(code);
  if (!Number.isNaN(numericCode) && PREFERRED_LANGUAGE_CODE_TO_I18N[numericCode]) {
    return PREFERRED_LANGUAGE_CODE_TO_I18N[numericCode];
  }
  return null;
};

export const getPreferredLanguageCodeFromI18n = (lng = i18n.language) =>
  PREFERRED_LANGUAGE_CODE_MAP[normalizeI18nLanguage(lng)] ?? 0;

export const extractPreferredLanguageCode = (payload) => {
  const raw =
    payload?.data?.preferredLanguageCode ??
    payload?.preferredLanguageCode ??
    (typeof payload?.data === "number" || typeof payload?.data === "string"
      ? payload.data
      : null);
  if (raw == null) return null;
  if (typeof raw === "number") return raw;
  if (raw in PREFERRED_LANGUAGE_CODE_MAP) {
    return PREFERRED_LANGUAGE_CODE_MAP[raw];
  }
  const numericCode = Number(raw);
  if (!Number.isNaN(numericCode) && PREFERRED_LANGUAGE_CODE_TO_I18N[numericCode]) {
    return numericCode;
  }
  return getPreferredLanguageCodeFromI18n(String(raw));
};

export const applyPreferredLanguageToI18n = async (code) => {
  const lng = getI18nLanguageFromCode(code);
  if (!lng) return null;

  localStorage.setItem("language", lng);
  if (normalizeI18nLanguage(i18n.language) !== lng) {
    await i18n.changeLanguage(lng);
  }
  return lng;
};

export const syncPreferredLanguageFromServer = async (getPreferredLanguage) => {
  const res = await getPreferredLanguage(undefined, false).unwrap();
  const code = extractPreferredLanguageCode(res);
  if (code == null) return null;
  await applyPreferredLanguageToI18n(code);
  return code;
};
